var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"table",attrs:{"loadObj":{},"option":{},"colObj":{
      opId:"3145",
      name:"抓取规则",
      parentId:"FETCH_ID",
      parentName:"网页抓取设置表",
      parentPath:"/system/fetchUrl",
      parentQuery:{
      },
      addForm:{
      },
      dataClass:2,
      col:[]
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }